import { Component, Inject, SecurityContext } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

import { MAT_DIALOG_DATA } from "@angular/material/dialog";

export interface ExternalLinkPopUpDialogData
{
    readonly url: string;
}

@Component({
    selector: "external-link-pop-up-dialog",
    templateUrl: "./externalLinkPopUpDialog.tmpl.html",
    styles: [
        `iframe {
             position: absolute;
             top: 0;
             left: 0;
             width: 100%;
             height: 90%;
         }`
    ],
    standalone: false
})
export class ExternalLinkPopUpDialogComponent
{
    constructor(
        @Inject(MAT_DIALOG_DATA) private readonly data: ExternalLinkPopUpDialogData,
        private readonly domSanitizer: DomSanitizer,
    )
    { }

    get url(): string
    {
        return this.domSanitizer.sanitize(SecurityContext.URL, this.data.url);
    }
}
